export const HOME = "/";
export const ERROR = "/errorPage";
export const MODULE = "/module/:id";
export const EVALUATIONS = "/evaluations";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/login";
export const ACCOUNT = "/account";
export const ADMIN = "/admin";
export const PASSWORD_FORGET = "/pw_forget";
export const COURSES = "/course/:id";
export const EVALUATION = "/evaluation/:id";
export const EVALUATIONPASSED = "/evaluation/result/:attemp/:course/:uid";
export const MANAGER = "/manager";
export const USERCONFIRMATION = "/confirm/";
export const RESCUERS = "/rescuers";
export const PASSWORDCHANGE = "/passwordReset/";
export const PROGRAMMANAGEMENT = "/management";
export const REAL_TIME_ALERS = "/alerts";
export const ALERT_LOG = "/alert/:key";
export const METAFORMS = "/createSingUpForm";
export const EDIT_METAFORM = "/editSingUpForm/:formId";
export const EDIT_METAFORM_EXACT = "editSingUpForm";
export const MANAGE_FORMS = "/rescuersForms_management";
export const VIEW_RESCUERS_RECORD = "/rescuersFormsView/:formId";
export const RESCUERS_SIGNUP = "/signUp/:formId";
export const REANIBEX_ALERT_POLICY = "/reanibex_alert/Privacy_policy";
export const REANIBEX_100_TRAINER_POLICY = "/R100TRAINER/Privacy_policy";
export const CREATE_ACCOUNT = "/createAccount/:key";
export const ONSITE_TRAINING = "/onsiteTraining";
export const ERMUA2022 = "/courseRegistration/:formId";
export const ACTIVERESCUER = "/activeRescuer";
export const WAITINGFORCOMPLETEUSERACCOUNT = "/completingProfile";
export const SENDREPORT = "/newReport";
export const COMUNICATIONTEST = "/comunicationAnalysis";
export const PROFILE = "/profile/:uid";
